import { render, staticRenderFns } from "./setPage.vue?vue&type=template&id=7e8a2e15&scoped=true&"
import script from "./setPage.vue?vue&type=script&lang=js&"
export * from "./setPage.vue?vue&type=script&lang=js&"
import style0 from "./setPage.vue?vue&type=style&index=0&id=7e8a2e15&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8a2e15",
  null
  
)

export default component.exports